<template>
  <div class="cert-image-picker" v-if="config">
    <div class="cert-image-picker-title">{{ config.imageNickName }}</div>
    <div class="cert-image-picker-gallery">
      <van-grid :column-num="4" gutter="8" :square="true" :border="false">
        <van-grid-item
          class="cert-image-picker-gallery-item"
          v-for="(val, index) in config.uploadedList"
          :key="index"
        >
          <div
            class="cert-image-picker-gallery-item-content"
            :style="{ backgroundImage: `url(${val.thumbnailURL})` }"
            @click="onImagePreviewTap(index)"
          >
            <div class="cert-image-picker-gallery-item-badge">
              <van-tag round type="warning">待提交</van-tag>
            </div>
          </div>
        </van-grid-item>
        <van-grid-item
          class="cert-image-picker-gallery-item"
          v-if="config.imageMaxQuantity > config.uploadedList.length"
        >
          <van-uploader
            multiple
            :after-read="onImageUpload"
            :show-upload="config.imageMaxQuantity > config.uploadedList.length"
          />
        </van-grid-item>
      </van-grid>
    </div>
    <van-popup
      class="popup"
      :value="popupVisible"
      position="bottom"
      :close-on-click-overlay="false"
    >
      <div class="popup-header">
        <div class="btn" @click="handleCancel">取消</div>
        <div>上传预览</div>
        <div class="btn" @click="handleConfirm">
          {{ hasFailedImage ? '重新上传' : '上传' }}
        </div>
      </div>
      <div class="popup-desc">{{ uploadableHint }}</div>
      <div class="popup-images">
        <van-uploader
          multiple
          v-model="imageDatas"
          :show-upload="imageMaxQuantity > imageDatas.length"
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
import { ImagePreview, Toast } from 'vant';

export default {
  props: ['config', 'confirm'],
  data() {
    return {
      imageDatas: [],
      popupVisible: false,
    };
  },
  computed: {
    imageMaxQuantity() {
      return this.config.imageMaxQuantity - this.config.uploadedList.length;
    },
    uploadableHint() {
      return `${this.config.imageNickName}本次只能上传${this.imageMaxQuantity}张`;
    },
    hasFailedImage() {
      return (
        this.imageDatas.filter(image => image.status === 'failed').length > 0
      );
    },
  },
  watch: {
    updateImages(images) {
      this.imageDatas = images.filter(image => image.status === 'failed');
    },
    imageDatas(val) {
      if (val.length === 0) {
        this.popupVisible = false;
      }
    },
  },
  methods: {
    onImageUpload(file) {
      this.imageDatas = Array.isArray(file) ? [...file] : [file];
      this.popupVisible = true;
    },
    handleCancel() {
      this.imageDatas = [];
    },
    handleConfirm() {
      if (this.imageMaxQuantity < this.imageDatas.length) {
        Toast.fail(this.uploadableHint);
        return;
      }

      Toast.loading({
        message: '正在上传...',
        forbidClick: true,
        duration: 0,
      });

      const params = {
        images: this.imageDatas,
        imageTag: this.config.imageTag,
      };

      this.confirm(params).then(images => {
        const failedImages = images.filter(image => image.status === 'failed');
        const uploadedImages = images.filter(
          image => image.status !== 'failed',
        );

        this.imageDatas = failedImages;
        this.config.uploadedList = [
          ...this.config.uploadedList,
          ...uploadedImages,
        ];

        Toast.clear();
      });
    },
    onImagePreviewTap(startPosition) {
      const images = this.config.uploadedList.map(image => image.imgURL);
      ImagePreview({ images, startPosition });
    },
  },
};
</script>

<style lang="less">
.cert-image-picker {
  &-title {
    font-size: 14px;
    padding: 0 16px;
  }

  &-gallery {
    padding: 8px;

    &-item {
      &-content {
        width: 100%;
        height: 100%;
        background-size: cover;
        border-radius: 8px;
      }

      .van-grid-item__content {
        padding: 0;
      }

      &-badge {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(0, 0, 0, 0.4);
        border-radius: 8px;
      }

      .van-uploader,
      .van-uploader__wrapper,
      .van-uploader__upload {
        width: 100%;
        height: 100%;
        margin: 0;
      }
    }
  }

  .popup {
    &-header {
      width: 100%;
      display: flex;
      justify-content: space-between;
      background-color: #fff;
      font-size: 16px;
      line-height: 44px;

      .btn {
        color: #108ee9;
        width: 90px;
        padding: 0 16px;
        &:last-of-type {
          text-align: right;
        }
      }
    }

    &-desc {
      font-size: 12px;
      color: #888;
      text-align: center;
    }

    &-images {
      min-height: 30vh;
      max-height: 40vh;
      padding: 16px 10px;
      overflow: auto;
    }
  }
}
</style>
